export const PRICE_MULTIPLIER = 10 ** 18;
